import * as tslib_1 from "tslib";
import RecipientPanel from './RecipientPanel';
import SubjectLine from './SubjectLine';
import { observer } from 'mobx-react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import InfoBar from 'owa-info-bar/lib/components/InfoBar';
import getInfoBarMessageViewState from 'owa-mail-compose-store/lib/utils/getInfoBarMessageViewState';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import canModifyRecipients from 'owa-mail-compose-store/lib/utils/canModifyRecipients';
import * as React from 'react';
var styles = require('./ComposeTop.scss');
var classNames = require('classnames/bind').bind(styles);
var ComposeTop = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeTop, _super);
    function ComposeTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onContentSizeChanged = function (delta, sourceElement) {
            if (_this.props.plugins) {
                _this.props.plugins.dockingPlugin.onContentSizeChanged(delta, sourceElement);
            }
        };
        return _this;
    }
    ComposeTop.prototype.trySetFocus = function (controlToFocus) {
        if (controlToFocus == 2 /* RecipientWellTo */) {
            this.recipientPanel.focus();
        }
        else if (controlToFocus == 5 /* SubjectLine */) {
            this.subjectLine.focus();
        }
    };
    ComposeTop.prototype.render = function () {
        var _this = this;
        var _a = this.props.viewState, infoBarIds = _a.infoBarIds, isInlineCompose = _a.isInlineCompose, showCompactRecipientWell = _a.showCompactRecipientWell, fromViewState = _a.fromViewState, ccRecipientWell = _a.ccRecipientWell, bccRecipientWell = _a.bccRecipientWell;
        var containerClassName = classNames(styles.topContainer, isReadingPaneCardUIEnabled() && styles.cardUI, {
            isInlineCompose: isInlineCompose,
        });
        var messages = [];
        for (var _i = 0, infoBarIds_1 = infoBarIds; _i < infoBarIds_1.length; _i++) {
            var messageId = infoBarIds_1[_i];
            var message = getInfoBarMessageViewState(messageId, this.props.viewState);
            if (message) {
                messages.push(message);
            }
        }
        return (React.createElement("div", { className: containerClassName },
            React.createElement(InfoBar, { messages: messages, className: classNames(styles.infoBar, isControlFeatureEnabled('rp-newInfoBarUI') && styles.newInfoBarUI) }),
            React.createElement(RecipientPanel, { isReadOnly: !canModifyRecipients(this.props.viewState), showCompactRecipientWell: showCompactRecipientWell, isFromShown: fromViewState.isFromShown, ccRecipientWell: ccRecipientWell, bccRecipientWell: bccRecipientWell, composeViewState: this.props.viewState, onContentSizeChanged: this.onContentSizeChanged, senderPersona: this.props.senderPersona, ref: function (ref) { return (_this.recipientPanel = ref); } }),
            !isInlineCompose && (React.createElement(SubjectLine, { composeViewState: this.props.viewState, ref: function (ref) { return (_this.subjectLine = ref); } }))));
    };
    ComposeTop = tslib_1.__decorate([
        observer
    ], ComposeTop);
    return ComposeTop;
}(React.Component));
export default ComposeTop;
//# sourceMappingURL=ComposeTop.js.map